module.exports = __webpack_public_path__ + "static/media/betamax.6ff919b6.svg";